module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3OhFN"))).then(() => parcelRequire('37nVf'));